import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticPasswordAccessComponent } from './static-password-access.component';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BrSdkModule } from '@bloomreach/ng-sdk';

@NgModule({
  declarations: [StaticPasswordAccessComponent],
  imports: [CommonModule, BrSdkModule],
  exports: [StaticPasswordAccessComponent],
})
export class StaticPasswordAccessModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Static Password Access': StaticPasswordAccessComponent,
    };
  }
}
